import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledFilter = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: ${(props) => (props.hasTags ? '8px' : '')};
  .filter-container {
    margin-top: 12px;
  }

  .filter-search-input {
    width: calc(90% - 8px);
  }

  .filter-btn {
    position: relative;
    padding: 7px;
    gap: 12px;
    color: ${COLOR.colorFilterInput};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${COLOR.borderFilterInput};
    img {
      width: 24px;
    }
    .circle-btn {
      position: absolute;
      top: -20%;
      left: 82%;
    }
  }

  .filter-category-input {
    display: flex;
    gap: 8px;
    width: 100%;
    align-items: center;
  }

  .my-voice {
    width: auto;
  }

  @media (max-width: 1170px) {
    display: flex;
    gap: 8px;
    flex-direction: column;
    justify-content: flex-start;

    .filter-search-input {
      width: 100%;
    }

    .my-voice {
      width: 100%;
    }
  }
`;

export const StyledSortVoiceFilterButton = styled('div')`
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px ${COLOR.boxShadow};
  padding: 8px;
  box-sizing: border-box;
  width: 200px;
  .item {
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    box-sizing: border-box;
    border-radius: 8px;
    cursor: pointer;
    width: 100%;
    display: flex;
    gap: 10px;
    margin-bottom: '0px';
    &:hover {
      color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
      background-color: ${(props) =>
        props.active ? COLOR.backgroundLinearProgress : TRANSPARENT_COLOR.dark};
    }
    &.active {
      color: ${COLOR.darkBlue};
      background-color: ${COLOR.backgroundLinearProgress};
    }
  }
`;

export const StyledTag = styled('div')`
  padding: 4px 8px;
  box-sizing: border-box;
  gap: 4px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  background-color: ${COLOR.backgroundDefault};
  border: 1px solid ${COLOR.borderDropdown};
`;

export const StyledListTags = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const StyledAdvancedFilter = styled('div')`
  box-shadow: 0px 4px 16px 0px #00000014;
  width: 400px;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 24px;
`;

export const StyledListTagsFilter = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const StyledTagFilter = styled('div')`
  padding: 4px 12px;
  height: 32px;
  display: flex;
  box-sizing: border-box;
  border-radius: 300px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  border: 1px solid #1e164e29;

  &.active {
    background-color: ${COLOR.backgroundRecordTime};
    border: 1px solid ${COLOR.indigo.default};
    color: ${COLOR.descriptionGray};
  }
`;
